class DocsService {
    constructor($state, $window, config, storageService) {
        this.$state = $state;
        this.$window = $window;
        this.docs = config.docs;
        this.serverUrl = storageService.getManagerHostname();
    }

    openHelp(query) {
        if(!query) {
            query = this.$state.current ? this.$state.current.data ? this.$state.current.data.docs : null : null;
        }
        this.openHelpWindow(query);
    }

    openHelpWindow(query) {
        if(query) {
            this.$window.open(`${this.docs.url}#${this.docs.query}=${query}`, '_blank');
        }
        else {
            this.$window.open(`${this.docs.url}`, '_blank');
        }
    }
}
DocsService.$inject = ['$state', '$window', 'config', 'storageService'];

module.exports = DocsService;


// WEBPACK FOOTER //
// ./src/azurebackup/services/docs.service.js